import { render } from "./CPurchaser.vue?vue&type=template&id=5f2e53c6"
import script from "./CPurchaser.vue?vue&type=script&lang=js"
export * from "./CPurchaser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__